import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import CopyrightIcon from '@mui/icons-material/Copyright';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

function ItemIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageEdit, setErrorMessageEdit] = useState("");

    // Form fields
    const [Name, setName] = useState('');
    const [CategoryId, setCategoryId] = useState(null);
    const [Rate, setRate] = useState('');
    const [TransportationCharges, setTransportationCharges] = useState('');
    const [GSTRate, setGSTRate] = useState('');
    const [HSNCode, setHSNCode] = useState('');

    // Category dropdown data
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchtableData();
        fetchCategories();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const fetchCategories = async () => {
        try {
            const response = await fetchData('CategoryApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const categoryOptions = response.response_data.map(cat => ({
                    value: cat.Id,
                    label: cat.Name
                }));
                setCategories(categoryOptions);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const fetchtableData = async () => {
        setLoading(true);
        fetchData('ItemApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
                console.log(response);
            })
            .catch((error) => {
                console.error('Error fetching ItemApi:', error);
                if (error.response && error.response.status === 401) {
                    logout();
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleDelete = async () => {
        deleteData('ItemApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ItemApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);
    const toggleModalGroup = () => {
        setIsModalGrpOpen(!isModalGrpOpen);
        setErrorMessage("");
        setName('');
        setCategoryId(null);
        setRate('');
        setTransportationCharges('');
        setGSTRate('');
        setHSNCode('');
    };

    const addGroupRecord = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (!Name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }

        if (!CategoryId) {
            setErrorMessage('Category is required !');
            setIsLoading(false);
            return;
        }

        if (!Rate) {
            setErrorMessage('Rate is required !');
            setIsLoading(false);
            return;
        }

        const isDuplicate = data.some(
            (item) => item.Name.trim().toLowerCase() === Name.trim().toLowerCase()
        );

        if (isDuplicate) {
            setErrorMessage("This Item Name already exists!");
            setIsLoading(false);
            return;
        }

        const Item = {
            CompanyId: companyId,
            Name,
            CategoryId: CategoryId.value,
            Rate: parseFloat(Rate),
            TransportationCharges: TransportationCharges ? parseFloat(TransportationCharges) : 0,
            GSTRate: GSTRate ? parseFloat(GSTRate) : 0,
            HSNCode,
            IsActive: true,
            CreatedBy: userId,
            CreatedDate: new Date(),
        };

        postData('ItemApi', Item, token)
            .then((response) => {
                console.log('Item Created success:', response);
                setSuccessMessage("Item Created successfully!");
                setErrorMessage("");
                setName("");
                setCategoryId(null);
                setRate('');
                setTransportationCharges('');
                setGSTRate('');
                setHSNCode('');
                setIsModalGrpOpen(false);
                window.location.reload();

                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    const openDetailModal = async (Id) => {
        try {
            const response = await fetchData('ItemApi', `/Item/${Id}`, token);
            if (response.responseCode === '1111') {
                const itemData = response.response_data;
                setUpdateData({
                    ...itemData,
                    CategoryId: categories.find(cat => cat.value === itemData.CategoryId)
                });
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    const toggleModalGrp2 = () => {
        setIsDetailModalOpen(false);
        setErrorMessageEdit("");
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const handleUpdateCategoryChange = (selectedOption) => {
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            CategoryId: selectedOption,
        }));
    };

    const [updatedData, setUpdateData] = useState({});

    const updateRecord = async (event) => {
        event.preventDefault();
        setIsUpdateLoading(true);

        if (!updatedData.Name) {
            setErrorMessageEdit('Name is required !');
            setIsUpdateLoading(false);
            return;
        }

        if (!updatedData.CategoryId) {
            setErrorMessageEdit('Category is required !');
            setIsUpdateLoading(false);
            return;
        }

        if (!updatedData.Rate) {
            setErrorMessageEdit('Rate is required !');
            setIsUpdateLoading(false);
            return;
        }

        try {
            const updatePayload = {
                ...updatedData,
                CategoryId: updatedData.CategoryId.value,
                Rate: parseFloat(updatedData.Rate),
                TransportationCharges: updatedData.TransportationCharges ? parseFloat(updatedData.TransportationCharges) : 0,
                GSTRate: updatedData.GSTRate ? parseFloat(updatedData.GSTRate) : 0,
            };

            await updateData('ItemApi', `${updatedData.Id}`, updatePayload, token);
            window.location.reload();
            setIsDetailModalOpen(false);
            fetchtableData();
        } catch (error) {
            console.error('Error updating record:', error);
        } finally {
            setIsUpdateLoading(false);
        }
    };

    return (
        <div className="container mt-2 mx-auto" style={{ maxWidth: '98%', padding: '0 16px' }}>
            <div className='mb-3 flex justify-between items-center'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', textTransform: 'uppercase' }}>Item</h6>

                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        backdropFilter: 'blur(4px)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <style>{`
                            .loader {
                                transform: rotateZ(45deg);
                                perspective: 1000px;
                                border-radius: 50%;
                                width: 48px;
                                height: 48px;
                                color: #fff;
                            }
                            .loader:before,
                            .loader:after {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: inherit;
                                height: inherit;
                                border-radius: 50%;
                                transform: rotateX(70deg);
                                animation: 1s spin linear infinite;
                            }
                            .loader:after {
                                color: #FF3D00;
                                transform: rotateY(70deg);
                                animation-delay: .4s;
                            }
                            @keyframes spin {
                                0%, 100% { box-shadow: .2em 0px 0 0px currentcolor; }
                                12% { box-shadow: .2em .2em 0 0 currentcolor; }
                                25% { box-shadow: 0 .2em 0 0px currentcolor; }
                                37% { box-shadow: -.2em .2em 0 0 currentcolor; }
                                50% { box-shadow: -.2em 0 0 0 currentcolor; }
                                62% { box-shadow: -.2em -.2em 0 0 currentcolor; }
                                75% { box-shadow: 0px -.2em 0 0 currentcolor; }
                                87% { box-shadow: .2em -.2em 0 0 currentcolor; }
                            }
                        `}</style>
                        <div className="loader"></div>
                        <span style={{ color: 'white', marginTop: '30px', fontSize: '16px', fontWeight: '500', letterSpacing: '0.5px' }}>
                            Loading...
                        </span>
                    </div>
                )}

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search items..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '280px' : '220px',
                            height: '32px',
                            border: '2px solid #e2e8f0',
                            borderRadius: '12px',
                            padding: '0 16px',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            outline: 'none',
                            borderColor: isFocused ? '#3b82f6' : '#e2e8f0',
                            boxShadow: isFocused ? '0 0 0 3px rgba(59, 130, 246, 0.1)' : '0 1px 2px rgba(0, 0, 0, 0.05)',
                            fontSize: '13px',
                            fontWeight: '500',
                            color: '#1e293b'
                        }}
                    />

                    <Tooltip
                        title="Add New Item" arrow
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: '#1e293b',
                                    color: 'white',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                },
                            },
                        }}
                    >
                        <Button
                            style={{
                                background: 'linear-gradient(to right, #041815ff, #045157ff)',
                                marginLeft: '8px', color: 'white', fontWeight: 'bolder',
                                height: '30px', fontSize: '11px', textTransform: 'uppercase',
                                marginTop: '-2px', borderRadius: '25px'
                            }}
                            onClick={toggleModalGroup}
                            className="linkcolor"
                            onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                        >
                            + Add Item
                        </Button>
                    </Tooltip>
                </div>
            </div>

            {/* Add Item Modal */}
            {isModalGrpOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                    <div
                        className="bg-white w-full overflow-hidden"
                        style={{
                            maxWidth: '900px',
                            maxHeight: '85vh',
                            borderRadius: '16px',
                            boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                            animation: 'zoomIn 0.3s ease-out'
                        }}
                    >
                        <div style={{
                            //background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            background: 'linear-gradient(135deg, #041815ff 0%, #045157ff 100%)',
                            padding: '14px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid rgba(255, 255, 255, 0.15)'
                        }}>
                            <div>
                                <h6 style={{
                                    color: 'white',
                                    fontSize: '16px',
                                    fontWeight: '700',
                                    margin: 0,
                                    letterSpacing: '-0.5px'
                                }}>
                                    New Item
                                </h6>
                                <p style={{
                                    color: 'rgba(255, 255, 255, 0.95)',
                                    fontSize: '12px',
                                    margin: '2px 0 0 0',
                                    fontWeight: '400'
                                }}>
                                    Add a new item to your system
                                </p>
                            </div>
                            <button
                                onClick={toggleModalGroup}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.15)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '32px',
                                    height: '32px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    color: 'white',
                                    fontSize: '20px',
                                    fontWeight: '300'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.25)';
                                    e.target.style.transform = 'rotate(90deg)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                                    e.target.style.transform = 'rotate(0deg)';
                                }}
                            >
                                ×
                            </button>
                        </div>

                        <div className="overflow-y-auto" style={{ maxHeight: 'calc(85vh - 120px)', padding: '16px 20px' }}>
                            {errorMessage && (
                                <div style={{
                                    background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
                                    border: '1.5px solid #fca5a5',
                                    borderRadius: '10px',
                                    padding: '10px 12px',
                                    marginBottom: '16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    boxShadow: '0 2px 8px rgba(239, 68, 68, 0.1)'
                                }}>
                                    <span style={{ fontSize: '18px', lineHeight: 1 }}>⚠️</span>
                                    <p style={{ color: '#991b1b', fontSize: '13px', margin: 0, fontWeight: '600' }}>{errorMessage}</p>
                                </div>
                            )}

                            <form onSubmit={addGroupRecord}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                color: '#1e293b',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                marginBottom: '6px',
                                                letterSpacing: '0.3px'
                                            }}>
                                                Item Name <span style={{ color: '#ef4444', fontSize: '13px' }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    transition: 'all 0.2s ease',
                                                    outline: 'none',
                                                    height: '36px',
                                                    fontWeight: '500',
                                                    color: '#1e293b'
                                                }}
                                                placeholder="Enter item name"
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#667eea';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e2e8f0';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label style={{
                                                display: 'block',
                                                color: '#1e293b',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                marginBottom: '6px',
                                                letterSpacing: '0.3px'
                                            }}>
                                                Category <span style={{ color: '#ef4444', fontSize: '13px' }}>*</span>
                                            </label>
                                            <Select
                                                value={CategoryId}
                                                onChange={setCategoryId}
                                                options={categories}
                                                placeholder="Select category"
                                                menuPortalTarget={document.body}   // ⭐ Makes dropdown appear outside container
                                                styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        borderRadius: '10px',
                                                        borderColor: state.isFocused ? '#667eea' : '#e5e7eb',
                                                        boxShadow: state.isFocused ? '0 0 0 2px rgba(102, 126, 234, 0.1)' : 'none',
                                                        '&:hover': { borderColor: '#667eea' },
                                                        minHeight: '32px',
                                                        height: '32px',
                                                        fontSize: '12.5px',
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,  // ⭐ ensures dropdown appears above all elements
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        padding: '6px 10px',
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                    }),
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label style={{
                                                display: 'block',
                                                color: '#1e293b',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                marginBottom: '6px',
                                                letterSpacing: '0.3px'
                                            }}>
                                                HSN Code
                                            </label>
                                            <input
                                                type="text"
                                                value={HSNCode}
                                                onChange={(e) => setHSNCode(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    transition: 'all 0.2s ease',
                                                    outline: 'none',
                                                    height: '36px',
                                                    fontWeight: '500',
                                                    color: '#1e293b'
                                                }}
                                                placeholder="Enter HSN code"
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#667eea';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e2e8f0';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label style={{
                                                display: 'block',
                                                color: '#1e293b',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                marginBottom: '6px',
                                                letterSpacing: '0.3px'
                                            }}>
                                                Rate <span style={{ color: '#ef4444', fontSize: '13px' }}>*</span>
                                            </label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                value={Rate}
                                                onChange={(e) => setRate(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    transition: 'all 0.2s ease',
                                                    outline: 'none',
                                                    height: '36px',
                                                    fontWeight: '500',
                                                    color: '#1e293b',
                                                    textAlign: 'right'
                                                }}
                                                placeholder="Enter rate"
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#667eea';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e2e8f0';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label style={{
                                                display: 'block',
                                                color: '#1e293b',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                marginBottom: '6px',
                                                letterSpacing: '0.3px'
                                            }}>
                                                Transportation Charges
                                            </label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                value={TransportationCharges}
                                                onChange={(e) => setTransportationCharges(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    transition: 'all 0.2s ease',
                                                    outline: 'none',
                                                    height: '36px',
                                                    fontWeight: '500',
                                                    color: '#1e293b',
                                                    textAlign: 'right'
                                                }}
                                                placeholder="Enter transportation charges"
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#667eea';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e2e8f0';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label style={{
                                                display: 'block',
                                                color: '#1e293b',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                marginBottom: '6px',
                                                letterSpacing: '0.3px'
                                            }}>
                                                GST Rate (%)
                                            </label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                value={GSTRate}
                                                onChange={(e) => setGSTRate(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    transition: 'all 0.2s ease',
                                                    outline: 'none',
                                                    height: '36px',
                                                    fontWeight: '500',
                                                    color: '#1e293b',
                                                    textAlign: 'right'
                                                }}
                                                placeholder="Enter GST rate"
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#667eea';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e2e8f0';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div style={{
                            background: 'linear-gradient(to right, #f8fafc, #f1f5f9)',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '10px',
                            borderTop: '1px solid #e2e8f0'
                        }}>
                            <button
                                onClick={toggleModalGroup}
                                disabled={isLoading}
                                style={{
                                    padding: '8px 20px',
                                    background: 'white',
                                    border: '2px solid #e2e8f0',
                                    borderRadius: '8px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: '#64748b',
                                    cursor: isLoading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease',
                                    opacity: isLoading ? 0.5 : 1,
                                    height: '36px'
                                }}
                                onMouseEnter={(e) => !isLoading && (e.target.style.background = '#f8fafc', e.target.style.borderColor = '#cbd5e1')}
                                onMouseLeave={(e) => !isLoading && (e.target.style.background = 'white', e.target.style.borderColor = '#e2e8f0')}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={addGroupRecord}
                                disabled={isLoading}
                                style={{
                                    padding: '8px 20px',
                                    //background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    background: 'linear-gradient(135deg, #041815ff 0%, #045157ff 100%)',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: 'white',
                                    cursor: isLoading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    boxShadow: '0 4px 14px rgba(102, 126, 234, 0.4)',
                                    opacity: isLoading ? 0.7 : 1,
                                    height: '36px'
                                }}
                                onMouseEnter={(e) => !isLoading && (e.target.style.transform = 'translateY(-2px)', e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.5)')}
                                onMouseLeave={(e) => !isLoading && (e.target.style.transform = 'translateY(0)', e.target.style.boxShadow = '0 4px 14px rgba(102, 126, 234, 0.4)')}
                            >
                                {isLoading ? (
                                    <>
                                        <CircularProgress size={16} color="inherit" />
                                        <span>Saving...</span>
                                    </>
                                ) : (
                                    <>
                                        <span>✓</span>
                                        <span>Add Item</span>
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Table */}
            <div className='w-full mb-2 flex' style={{ maxHeight: '480px', overflowY: 'auto', width: '100%', borderRadius: '12px' }}>
                <TableContainer component={Paper} sx={{ boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', borderRadius: '12px' }}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#134B70', padding: '2px' }}>
                            <TableRow>
                                <TableCell style={{
                                    background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                }}>
                                    Sl.No
                                </TableCell>
                                <TableCell style={{
                                    background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                }}>
                                    Name
                                </TableCell>
                                <TableCell style={{
                                    background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                }}>
                                    Category
                                </TableCell>
                                <TableCell style={{
                                    background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                }}>
                                    Rate
                                </TableCell>
                                <TableCell style={{
                                    background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                }}>
                                    Transport
                                </TableCell>
                                <TableCell style={{
                                    background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                }}>
                                    GST %
                                </TableCell>
                                <TableCell style={{
                                    background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                }}>
                                    HSN Code
                                </TableCell>
                                <TableCell style={{
                                    background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                }}>

                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData && filteredData.map((item, index) => (
                                <TableRow
                                    key={item.Id}
                                    sx={{
                                        '&:hover': { backgroundColor: '#f8fafc' },
                                        transition: 'all 0.2s ease',
                                        cursor: 'pointer',
                                        borderBottom: '1px solid #e2e8f0'
                                    }}
                                >
                                    <TableCell sx={{
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#64748b',
                                        borderRight: '1px solid #f1f5f9'
                                    }}>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '6px 12px',
                                        fontSize: '13px',
                                        fontWeight: '500',
                                        color: '#1e293b',
                                        borderRight: '1px solid #f1f5f9'
                                    }}>
                                        {item.Name}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '6px 12px',
                                        fontSize: '13px',
                                        fontWeight: '500',
                                        color: '#1e293b',
                                        borderRight: '1px solid #f1f5f9'
                                    }}>
                                        {item.CategoryName}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '6px 12px',
                                        textAlign: 'right',
                                        fontSize: '13px',
                                        fontWeight: '500',
                                        color: '#1e293b',
                                        borderRight: '1px solid #f1f5f9'
                                    }}>
                                        {item.Rate?.toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '6px 12px',
                                        textAlign: 'right',
                                        fontSize: '13px',
                                        fontWeight: '500',
                                        color: '#1e293b',
                                        borderRight: '1px solid #f1f5f9'
                                    }}>
                                        {item.TransportationCharges?.toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '6px 12px',
                                        textAlign: 'right',
                                        fontSize: '13px',
                                        fontWeight: '500',
                                        color: '#1e293b',
                                        borderRight: '1px solid #f1f5f9'
                                    }}>
                                        {item.GSTRate?.toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '6px 12px',
                                        fontSize: '13px',
                                        fontWeight: '500',
                                        color: '#1e293b',
                                        borderRight: '1px solid #f1f5f9'
                                    }}>
                                        {item.HSNCode}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '4px',
                                        textAlign: 'center',
                                        borderRight: 'none'
                                    }}>
                                        <Tooltip
                                            title="Edit Item" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#3b82f6',
                                                        color: 'white',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        padding: '6px 10px',
                                                        borderRadius: '6px',
                                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton
                                                onClick={() => openDetailModal(item.Id)}
                                                sx={{
                                                    '&:hover': {
                                                        backgroundColor: '#eff6ff',
                                                        transform: 'scale(1.1)'
                                                    },
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <EditIcon style={{ color: '#3b82f6', fontSize: '18px' }} />
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip
                                            title="Delete Item" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#ef4444',
                                                        color: 'white',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        padding: '6px 10px',
                                                        borderRadius: '6px',
                                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton
                                                onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))}
                                                sx={{
                                                    '&:hover': {
                                                        backgroundColor: '#fef2f2',
                                                        transform: 'scale(1.1)'
                                                    },
                                                    transition: 'all 0.2s ease',
                                                }}
                                            >
                                                {item.IsActive ? <DeleteIcon style={{ color: '#ef4444', fontSize: '18px' }} /> : <ActivateIcon style={{ color: '#10b981', fontSize: '18px' }} />}
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={confirmDialogOpen}
                onClose={closeConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '16px',
                        padding: '8px',
                        minWidth: '400px',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title" style={{
                    fontSize: '20px',
                    fontWeight: '700',
                    color: '#1e293b',
                    padding: '20px 24px 12px'
                }}>
                    Delete Item?
                </DialogTitle>
                <DialogContent style={{ padding: '12px 24px 24px' }}>
                    <DialogContentText id="alert-dialog-description" style={{
                        fontSize: '14px',
                        color: '#64748b',
                        fontWeight: '500'
                    }}>
                        Are you sure you want to delete this item? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ padding: '12px 24px 20px', gap: '8px' }}>
                    <button
                        onClick={closeConfirmDialog}
                        style={{
                            background: 'white',
                            color: '#64748b',
                            border: '2px solid #e2e8f0',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.background = '#f8fafc'}
                        onMouseLeave={(e) => e.target.style.background = 'white'}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleDelete}
                        style={{
                            background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 4px 12px rgba(239, 68, 68, 0.4)'
                        }}
                        onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                        onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                    >
                        Delete
                    </button>
                </DialogActions>
            </Dialog>

            {/* Edit Item Modal */}
            {isDetailModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                    <div
                        className="bg-white w-full overflow-hidden"
                        style={{
                            maxWidth: '900px',
                            maxHeight: '85vh',
                            borderRadius: '16px',
                            boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                            animation: 'zoomIn 0.3s ease-out'
                        }}
                    >
                        <div style={{
                            //background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                            padding: '14px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid rgba(255, 255, 255, 0.15)'
                        }}>
                            <div>
                                <h6 style={{
                                    color: 'white',
                                    fontSize: '16px',
                                    fontWeight: '700',
                                    margin: 0,
                                    letterSpacing: '-0.5px'
                                }}>
                                    Edit Item
                                </h6>
                                <p style={{
                                    color: 'rgba(255, 255, 255, 0.95)',
                                    fontSize: '12px',
                                    margin: '2px 0 0 0',
                                    fontWeight: '400'
                                }}>
                                    Update item information
                                </p>
                            </div>
                            <button
                                onClick={toggleModalGrp2}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.15)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '32px',
                                    height: '32px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    color: 'white',
                                    fontSize: '20px',
                                    fontWeight: '300'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.25)';
                                    e.target.style.transform = 'rotate(90deg)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                                    e.target.style.transform = 'rotate(0deg)';
                                }}
                            >
                                ×
                            </button>
                        </div>

                        <div className="overflow-y-auto" style={{ maxHeight: 'calc(85vh - 120px)', padding: '16px 20px' }}>
                            {errorMessageEdit && (
                                <div style={{
                                    background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
                                    border: '1.5px solid #fca5a5',
                                    borderRadius: '10px',
                                    padding: '10px 12px',
                                    marginBottom: '16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    boxShadow: '0 2px 8px rgba(239, 68, 68, 0.1)'
                                }}>
                                    <span style={{ fontSize: '18px', lineHeight: 1 }}>⚠️</span>
                                    <p style={{ color: '#991b1b', fontSize: '13px', margin: 0, fontWeight: '600' }}>{errorMessageEdit}</p>
                                </div>
                            )}

                            <form onSubmit={updateRecord}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                color: '#1e293b',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                marginBottom: '6px',
                                                letterSpacing: '0.3px'
                                            }}>
                                                Item Name <span style={{ color: '#ef4444', fontSize: '13px' }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="Name"
                                                value={updatedData.Name || ''}
                                                onChange={handleUpdateInputChange}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    transition: 'all 0.2s ease',
                                                    outline: 'none',
                                                    height: '36px',
                                                    fontWeight: '500',
                                                    color: '#1e293b'
                                                }}
                                                placeholder="Enter item name"
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#667eea';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e2e8f0';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label style={{
                                                display: 'block',
                                                color: '#1e293b',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                marginBottom: '6px',
                                                letterSpacing: '0.3px'
                                            }}>
                                                Category <span style={{ color: '#ef4444', fontSize: '13px' }}>*</span>
                                            </label>
                                            <Select
                                                value={updatedData.CategoryId}
                                                onChange={handleUpdateCategoryChange}
                                                options={categories}
                                                placeholder="Select category"
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: '36px',
                                                        height: '36px',
                                                        fontSize: '13px',
                                                        borderColor: '#e2e8f0',
                                                        borderWidth: '2px',
                                                        borderRadius: '8px',
                                                        '&:hover': { borderColor: '#667eea' }
                                                    }),
                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        height: '36px',
                                                        padding: '0 8px'
                                                    }),
                                                    input: (base) => ({
                                                        ...base,
                                                        margin: '0px',
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        height: '36px',
                                                    }),
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label style={{
                                                display: 'block',
                                                color: '#1e293b',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                marginBottom: '6px',
                                                letterSpacing: '0.3px'
                                            }}>
                                                HSN Code
                                            </label>
                                            <input
                                                type="text"
                                                name="HSNCode"
                                                value={updatedData.HSNCode || ''}
                                                onChange={handleUpdateInputChange}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    transition: 'all 0.2s ease',
                                                    outline: 'none',
                                                    height: '36px',
                                                    fontWeight: '500',
                                                    color: '#1e293b'
                                                }}
                                                placeholder="Enter HSN code"
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#667eea';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e2e8f0';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label style={{
                                                display: 'block',
                                                color: '#1e293b',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                marginBottom: '6px',
                                                letterSpacing: '0.3px'
                                            }}>
                                                Rate <span style={{ color: '#ef4444', fontSize: '13px' }}>*</span>
                                            </label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                name="Rate"
                                                value={updatedData.Rate || ''}
                                                onChange={handleUpdateInputChange}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    transition: 'all 0.2s ease',
                                                    outline: 'none',
                                                    height: '36px',
                                                    fontWeight: '500',
                                                    color: '#1e293b',
                                                    textAlign: 'right'
                                                }}
                                                placeholder="Enter rate"
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#667eea';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e2e8f0';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label style={{
                                                display: 'block',
                                                color: '#1e293b',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                marginBottom: '6px',
                                                letterSpacing: '0.3px'
                                            }}>
                                                Transportation Charges
                                            </label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                name="TransportationCharges"
                                                value={updatedData.TransportationCharges || ''}
                                                onChange={handleUpdateInputChange}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    transition: 'all 0.2s ease',
                                                    outline: 'none',
                                                    height: '36px',
                                                    fontWeight: '500',
                                                    color: '#1e293b',
                                                    textAlign: 'right'
                                                }}
                                                placeholder="Enter transportation charges"
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#667eea';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e2e8f0';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>

                                        <div>
                                            <label style={{
                                                display: 'block',
                                                color: '#1e293b',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                marginBottom: '6px',
                                                letterSpacing: '0.3px'
                                            }}>
                                                GST Rate (%)
                                            </label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                name="GSTRate"
                                                value={updatedData.GSTRate || ''}
                                                onChange={handleUpdateInputChange}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e2e8f0',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    transition: 'all 0.2s ease',
                                                    outline: 'none',
                                                    height: '36px',
                                                    fontWeight: '500',
                                                    color: '#1e293b',
                                                    textAlign: 'right'
                                                }}
                                                placeholder="Enter GST rate"
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#667eea';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e2e8f0';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div style={{
                            background: 'linear-gradient(to right, #f8fafc, #f1f5f9)',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '10px',
                            borderTop: '1px solid #e2e8f0'
                        }}>
                            <button
                                onClick={toggleModalGrp2}
                                disabled={isUpdateLoading}
                                style={{
                                    padding: '8px 20px',
                                    background: 'white',
                                    border: '2px solid #e2e8f0',
                                    borderRadius: '8px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: '#64748b',
                                    cursor: isUpdateLoading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease',
                                    opacity: isUpdateLoading ? 0.5 : 1,
                                    height: '36px'
                                }}
                                onMouseEnter={(e) => !isUpdateLoading && (e.target.style.background = '#f8fafc', e.target.style.borderColor = '#cbd5e1')}
                                onMouseLeave={(e) => !isUpdateLoading && (e.target.style.background = 'white', e.target.style.borderColor = '#e2e8f0')}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={updateRecord}
                                disabled={isUpdateLoading}
                                style={{
                                    padding: '8px 20px',
                                    //background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: 'white',
                                    cursor: isUpdateLoading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    boxShadow: '0 4px 14px rgba(102, 126, 234, 0.4)',
                                    opacity: isUpdateLoading ? 0.7 : 1,
                                    height: '36px'
                                }}
                                onMouseEnter={(e) => !isUpdateLoading && (e.target.style.transform = 'translateY(-2px)', e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.5)')}
                                onMouseLeave={(e) => !isUpdateLoading && (e.target.style.transform = 'translateY(0)', e.target.style.boxShadow = '0 4px 14px rgba(102, 126, 234, 0.4)')}
                            >
                                {isUpdateLoading ? (
                                    <>
                                        <CircularProgress size={16} color="inherit" />
                                        <span>Updating...</span>
                                    </>
                                ) : (
                                    <>
                                        <span>✓</span>
                                        <span>Update Item</span>
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div style={{
                position: 'fixed',
                bottom: '12px',
                right: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                padding: '0.3rem 0.65rem',
                background: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '14px',
                boxShadow: '0 1px 6px rgba(0, 0, 0, 0.06)',
                fontFamily: 'serif',
                fontWeight: 'bold',
                color: '#2c3e50',
                fontSize: '0.7rem',
                backdropFilter: 'blur(10px)'
            }}>
                <CopyrightIcon />
                <b>EFFTABS SOLUTIONS LLP</b>
            </div>
        </div>
    );
}

export default ItemIndex;